import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { formValidator } from "../../../../helpers";
import { InputGroup, Modal, Button } from "../../../../UI";
import { altzoneData } from "../../../../store/actions";
import Container from "./styles";

const AdminForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [citiesInput, setCitiesInput] = useState('');
  const [dropOffCitiesInput, setDropOffCitiesInput] = useState('');

  const [formData, setFormData] = useState({
    name: "",
    state: "",
    amount: 0,
    operation_cost: 0,
  });

  const handleInput = ({ target: { value, name } }) => {
    setFormData((s) => ({
      ...s,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    if (
      formValidator(document.forms["admin-form"].getElementsByTagName("input"))
    ) {
      // Parse comma-separated cities
      const cities = citiesInput
        .split(',')
        .map(city => city.trim())
        .filter(city => city.length > 0);
      
      const dropOffCities = dropOffCitiesInput
        .split(',')
        .map(city => city.trim())
        .filter(city => city.length > 0);
      
      // Validate cities and drop-off cities
      if (cities.length === 0) {
        alert("Please add at least one pickup city");
        return;
      }
      
      if (dropOffCities.length === 0) {
        alert("Please add at least one drop-off city");
        return;
      }
      
      const zonePayload = {
        name: formData.name,
        state: formData.state,
        cities: cities,
        drop_off_cities: dropOffCities,
        amount: parseFloat(formData.amount) || 0,
        operation_cost: parseFloat(formData.operation_cost) || 0,
      };
      
      // Add id for update action
      if (params.action === 'update' && state && state.state && state.state.id) {
        zonePayload.id = state.state.id;
      }
      
      setLoading(true);

      dispatch(altzoneData(zonePayload, params.action))
        .then((response) => {
          if (response && response.success) {
            navigate(-1);
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(()=>{
    if (params.action === "update" && state && state.state) {
      const zoneData = state.state;
      
      // Convert arrays back to comma-separated strings for editing
      setCitiesInput(zoneData.cities ? zoneData.cities.join(', ') : '');
      setDropOffCitiesInput(zoneData.drop_off_cities ? zoneData.drop_off_cities.join(', ') : '');
      
      setFormData({
        name: zoneData.name || '',
        state: zoneData.state || '',
        amount: zoneData.amount || 0,
        operation_cost: zoneData.operation_cost || 0,
      });
    }
  }, [params.action, state]);
  
  return (
    <Container>
      <Modal showModal={true}>
        <div className="adminForm--container">
          <header>
            <h2>{params.action !== "add" ? "Edit Zone" : "Add New Zone"}</h2>
            <p>Kindly fill this form below</p>
          </header>
          <form
            noValidate
            name="admin-form"
            className="admin-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            {params.action !== "resetPassword" && (
              <>
                <InputGroup
                  label={"Zone Name"}
                  name="name"
                  value={formData.name}
                  onChange={handleInput}
                  required
                  data-label="name"
                  type="text"
                  placeholder="Enter the zone name"
                />
                <InputGroup
                  name="state"
                  label={"State"}
                  data-label="state"
                  value={formData.state}
                  required
                  type="text"
                  onChange={handleInput}
                  placeholder="Please select"
                />
                <InputGroup
                  label="Pickup Cities"
                  name="cities"
                  value={citiesInput}
                  onChange={(e) => setCitiesInput(e.target.value)}
                  required
                  data-label="pickup cities"
                  type="text"
                  placeholder="Enter cities separated by commas (e.g. Lagos, Ikeja, Lekki)"
                />
                <div style={{ height: 15 }}></div>
                <InputGroup
                  label="Drop Off Cities"
                  name="drop_off_cities"
                  value={dropOffCitiesInput}
                  onChange={(e) => setDropOffCitiesInput(e.target.value)}
                  required
                  data-label="drop off cities"
                  type="text"
                  placeholder="Enter cities separated by commas (e.g. Abuja, Kano, Port Harcourt)"
                />
                <div style={{ height: 15 }}></div>
                <InputGroup
                  name="amount"
                  label={"Price/miles"}
                  data-label="amount"
                  value={formData.amount}
                  required
                  type="number"
                  onChange={handleInput}
                  placeholder="Enter amount"
                />
                <InputGroup
                  name="operation_cost"
                  label={"Operational costs"}
                  data-label="operation_cost"
                  value={formData.operation_cost}
                  required
                  type="number"
                  onChange={handleInput}
                  placeholder="Enter amount"
                />
              </>
            )}

            <Button type="submit" spinnerWithTxt loading={loading}>
              {params.action === "resetPassword"
                ? "Reset Password"
                : "Save Zone"}
            </Button>
          </form>
        </div>
      </Modal>
    </Container>
  );
};

export default AdminForm;
